import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);
  // Cache-bust per app load so a deployed translation update is never masked by a stale
  // browser-cached copy of the static i18n JSON file.
  private readonly cacheBuster = Date.now();

  getTranslation(langPath: string) {
    return this.http.get<Translation>(`/i18n/${langPath}.json?v=${this.cacheBuster}`);
  }
}
